import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { useEffect } from "react";

export const useAccountSwitched = () => {
  const { showGrowl } = useGrowlStoreActions();
  const { data: currentAccount } = useCurrentAccount();
  const { data: currentProfile } = useCurrentProfile();

  useEffect(() => {
    const isAccountSwitched = currentProfile.accountId && currentProfile.accountId !== currentAccount.id;

    if (isAccountSwitched) {
      showGrowl({
        message: "You switched account, be careful",
        kind: "alert"
      });
    }
  }, [currentAccount.id]); // eslint-disable-line react-hooks/exhaustive-deps
};
